{
	"colorBlue": "Blue",
	"colorGreen": "Green",
	"colorNone": "No Color",
	"colorPurple": "Purple",
	"colorRed": "Red",
	"colorYellow": "Yellow"
}
